import OpenDataCarto from "./opendata-carto.js";

class RteCarto extends OpenDataCarto {

    constructor(types) {
        super(types);
        this.opacity = 1;
    }

    get baseUrl() {
        return "https://odre.opendatasoft.com"
    }
    
    get geoField() {

    }
    
}

export default RteCarto;